import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { loadStripe } from "@stripe/stripe-js";
import InnerHTML from 'dangerously-set-html-content';
import Response from './components/Response';
import { properties } from './assets/properties';
import './App.css';
import './css/template.css';
import { env } from './env';
import StatusTemplate from "./components/StatusTemplate";

function App() {
  //setting up the state variables
  const [stripePromise, setStripePromise] = useState();
  const [isJSONResponse, setIsJSONResponse] = useState(true);
  const [responsedata, setResponseData] = useState();
  const [clientSecret, setClientSecret] = useState("");
  const [redirectRef, setRedirectRef] = useState(); // for enhanced redirect flow
  const [errorMsg, setErrorMsg] = useState();
  const [isPaymentCompleted, setIsPaymentCompleted] = useState(false);
  const [completedTemplate, setCompletedTemplate] = useState("");
  var refParam;

  useEffect(() => {
    const getClientSecret = async () => {
      try {
        if (window.location.pathname === '/') {
          var request = {
            method: properties.methodList.GET,
            headers: new Headers({ 'Content-type': properties.contentType.formUrlEncoded },),
            credentials: "include"
          }
          let baseURL = env.REACT_APP_BASE_URL;
          let urlParam = new URLSearchParams(window.location.search);
          refParam = urlParam.get("ref");
          if (refParam) {
            setRedirectRef(refParam); // for enhanced redirect flow
          }
          fetch(baseURL + (properties.apiList.templateURL + ("?ref=" + refParam)), request, true)
            .then(response => {
              const contentType = response.headers.get("content-type");
              const responseStatus = response.status;
              if (contentType && contentType.indexOf(properties.contentType.json) !== -1) {
                return response.json().then(responsedata => {
                  if (responsedata.returnCode) {
                    setErrorMsg(responsedata.returnMessage);
                  }
                  else if (responseStatus === 422) {
                    setIsPaymentCompleted(true);
                    setCompletedTemplate(responsedata.template);
                  }
                  else {
                    setClientSecret(responsedata.clientSecret);
                    setResponseData(responsedata);
                    setStripePromise(loadStripe(responsedata.publishableKey));
                    setIsJSONResponse(true);
                  }
                });
              } else {
                return response.text().then(responsedata => {
                  setIsJSONResponse(false);
                  setResponseData(responsedata);
                });
              }
            });
        }
      } catch (e) {
        console.log('Error Occurs');
        console.log(e);
      }
    }
    // fetching the ClientSecret and Template
    getClientSecret();
  }, []);

  if (isJSONResponse) {
    return (
      <div className="App">
        {(isPaymentCompleted && completedTemplate) && (<StatusTemplate template={completedTemplate} />)}
        {(clientSecret && responsedata && stripePromise) && (
            <Router>
              <Routes>
                <Route path="/" element={<Response responsedata={responsedata} errorMsg={null} redirectRef={redirectRef} stripePromise={stripePromise} />} />
              </Routes>
            </Router>
        )}
        {errorMsg && (
          <Router>
            <Routes>
              <Route path="/" element={<Response responsedata={responsedata} errorMsg={errorMsg} />} />
            </Routes>
          </Router>
        )}
      </div>
    );
  }
  else {
    return (<div><InnerHTML html={responsedata} /></div>)
  }
}

export default App;